(() => {
  const THRESHOLD = 7900;
  const BAR_CLASS = 'mara-cart-progress';

  function money(cents) {
    try {
      return new Intl.NumberFormat('es-ES', {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'EUR'
      }).format(cents / 100);
    } catch (e) {
      return `${(cents / 100).toFixed(2)} €`;
    }
  }

  function addStyles() {
    if (document.getElementById('mara-cart-progress-styles')) return;

    const style = document.createElement('style');
    style.id = 'mara-cart-progress-styles';

    style.textContent = `
      .${BAR_CLASS} {
        width: 100%;
        margin-bottom: 18px;
        padding: 0;
      }

      .${BAR_CLASS}__message {
        margin: 0 0 9px;
        font-size: 13px;
        line-height: 1.4;
        text-align: center;
      }

      .${BAR_CLASS}__track {
        width: 100%;
        height: 6px;
        border-radius: 999px;
        overflow: hidden;
        background: rgba(0, 0, 0, 0.10);
      }

      .${BAR_CLASS}__fill {
        display: block;
        width: 0;
        height: 100%;
        border-radius: 999px;
        background: currentColor;
        transition: width 0.35s ease;
      }

      .${BAR_CLASS}--complete .${BAR_CLASS}__message {
        font-weight: 600;
      }
    `;

    document.head.appendChild(style);
  }

  function findCartContainers() {
    return document.querySelectorAll(`
      .cart-drawer__footer,
      .cart-drawer__summary,
      .cart__summary,
      .cart-page__summary,
      cart-drawer-component .drawer__footer
    `);
  }

  function createBar(container) {
    let bar = container.querySelector(`.${BAR_CLASS}`);

    if (bar) return bar;

    bar = document.createElement('div');
    bar.className = BAR_CLASS;
    bar.setAttribute('aria-live', 'polite');

    bar.innerHTML = `
      <p class="${BAR_CLASS}__message"></p>

      <div
        class="${BAR_CLASS}__track"
        role="progressbar"
        aria-valuemin="0"
        aria-valuemax="7900"
        aria-valuenow="0"
      >
        <span class="${BAR_CLASS}__fill"></span>
      </div>
    `;

    container.insertBefore(bar, container.firstChild);

    return bar;
  }

  function update(cart) {
    const total = Number(cart?.original_total_price || 0);

    const complete = total >= THRESHOLD;
    const progress = Math.min(100, (total / THRESHOLD) * 100);
    const remaining = Math.max(0, THRESHOLD - total);

    findCartContainers().forEach(container => {
      const bar = createBar(container);

      const message = bar.querySelector(
        `.${BAR_CLASS}__message`
      );

      const fill = bar.querySelector(
        `.${BAR_CLASS}__fill`
      );

      const track = bar.querySelector(
        `.${BAR_CLASS}__track`
      );

      fill.style.width = `${progress}%`;

      track.setAttribute(
        'aria-valuenow',
        String(Math.min(total, THRESHOLD))
      );

      bar.classList.toggle(
        `${BAR_CLASS}--complete`,
        complete
      );

      if (complete) {
        message.textContent =
          '🎉 ¡Has conseguido un 10% de descuento!';
      } else {
        message.textContent =
          `✨ Te faltan ${money(remaining)} para conseguir un 10% de descuento`;
      }
    });
  }

  async function refreshCart() {
    try {
      const root = window.Shopify?.routes?.root || '/';

      const response = await fetch(
        `${root}cart.js`,
        {
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json'
          }
        }
      );

      if (!response.ok) return;

      const cart = await response.json();

      update(cart);
    } catch (error) {
      console.warn(
        'Mara Monclair: no se pudo actualizar la barra del carrito',
        error
      );
    }
  }

  function init() {
    addStyles();
    refreshCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      init,
      { once: true }
    );
  } else {
    init();
  }

  document.addEventListener(
    'cart:refresh',
    refreshCart
  );

  document.addEventListener(
    'shopify:cart:lines-update',
    refreshCart
  );

  document.addEventListener(
    'shopify:section:load',
    refreshCart
  );

  const observer = new MutationObserver(() => {
    if (findCartContainers().length) {
      refreshCart();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();